import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import RenderAvatar from '../../partials/Avatar'
import ScrollArea from '../../../partials/ScrollArea'

import color from '../../../../utils/color'

import style from './style'

export const UserEditor = props => {
  return (
    <Col>
      <Row
        className={css(
          style.form.group,
          style[props.theme.name] ? style[props.theme.name].form.group : null
        )}
      >
        <Col>
          <Row>
            <Col>
              <h4 className={css(style.headers.h4)}>Details</h4>
            </Col>
          </Row>

          <ProfileRow {...props} />
        </Col>
      </Row>

      <Row
        className={css(
          style.form.group,
          style[props.theme.name] ? style[props.theme.name].form.group : null
        )}
      >
        <Col>
          <Row>
            <Col>
              <h4 className={css(style.headers.h4)}>
                Groups ({props.community.groups.length})
              </h4>
            </Col>
          </Row>
          <Row>
            <Col>
              <ScrollArea
                style={{
                  height: `300px`
                }}
              >
                <Col
                  className={css(
                    style.list.list,
                    style[props.theme.name]
                      ? style[props.theme.name].list.list
                      : null
                  )}
                >
                  <Row
                    className={css(
                      style.list.header,
                      style[props.theme.name]
                        ? style[props.theme.name].list.header
                        : null
                    )}
                  />
                  {props.community.groups.map((group, index) => (
                    <Row
                      key={`${group.id}_${index}`}
                      data-gid={group.id}
                      onClick={props.onGroupClick}
                      className={css(
                        style.list.row,
                        style[props.theme.name]
                          ? style[props.theme.name].list.row
                          : null
                      )}
                    >
                      <Col
                        xs='auto'
                        className={`d-flex align-items-center justify-content-center`}
                      >
                        <span
                          className={css(
                            style.form.checkbox,
                            style[props.theme.name]
                              ? style[props.theme.name].form.checkbox
                              : null,
                            group.users.includes(props.id)
                              ? style[props.theme.name]
                                ? (style.form.checkbox_check,
                                  style[props.theme.name].form.checkbox_check)
                                : style.form.checkbox_check
                              : null
                          )}
                        />
                      </Col>
                      <Col
                        className={`d-flex align-items-center justify-content-center`}
                      >
                        {group.name}
                      </Col>
                      <Col />
                    </Row>
                  ))}
                </Col>
              </ScrollArea>
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  )
}

export const ProfileRow = props => {
  if (!props.firstName || !props.lastName) {
    return null
  }

  const userFullName = `${props.firstName} ${props.lastName}`
  const userHexColor = color.stringToHex(userFullName)
  const fontHexColor = color.contrastHex(userHexColor)

  const date = new Date(props.createdAt)
  const _date = {
    day: date.getUTCMonth(),
    month: date.toLocaleString('en-us', { month: 'short' }),
    year: date.getUTCFullYear()
  }

  _date.day = `${('' + _date.day).length > 1 ? _date.day : '0' + _date.day}`

  return (
    <Row>
      <Col xs='12' lg='6'>
        <Row>
          <Col xs='auto'>
            <RenderAvatar
              bgColor={userHexColor}
              textColor={fontHexColor}
              firstName={props.firstName}
              lastName={props.lastName}
            />
          </Col>
          <Col>
            <Row>
              <Col xs='auto'>
                <span className={css(style.user.name)}>{userFullName}</span>
              </Col>
            </Row>
            <Row>
              <Col>
                <span className={css(style.user.country)}>
                  {props.country || ''}
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col>
        <Row>
          <Col>
            <span className={css(style.user.info)}>
              <i className={`fa fa-envelope ${css(style.user.icon)}`} />
              {props.email}
            </span>
          </Col>
        </Row>
        {!props.phone ? null : (
          <Row>
            <Col>
              <span className={css(style.user.info)}>
                <i className={`fa fa-phone ${css(style.user.icon)}`} />
                {props.phone}
              </span>
            </Col>
          </Row>
        )}
        {!props.createdAt ? null : (
          <Row>
            <Col>
              <span className={css(style.user.info)}>
                <i className={`fa fa-table ${css(style.user.icon)}`} />
                joined {_date.day} {_date.month} {_date.year}
              </span>
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  )
}

export default UserEditor



// WEBPACK FOOTER //
// ./src/components/Community/partials/UserEditor/index.js